import * as React from "react";
import { theme } from "styles/theme";
import { ProductCollectionBreadcrumbs } from "./product-collection-breadcrumbs";

interface ILink {
    component?: string;
    displayName: string;
    path?: string;
}

interface IProps {
    links: ILink[];
    brandEntities: any;
    scope: any;
    router: any;
}

const styles = {
    container: {
        display: "flex",
        padding: "4px",
        flexShrink: 0,
        flexGrow: 0,
    },
    pill: {
        backgroundColor: theme.palette.darkGrey,
        color: theme.palette.canvasColor,
        padding: "0 12px",
        borderRadius: "12px",
        margin: "0 6px",
    },
};

export const ProductCollectionSummary = (props: IProps) => {
    const { brandEntities, links, scope, router } = props;
    if (!brandEntities || router.location.query.mode) {
        return null;
    }

    return (
        <div>
            <div style={styles.container}>
                <ProductCollectionBreadcrumbs
                    brandEntities={brandEntities}
                    links={links}
                    scope={scope}
                    router={router}
                />
            </div>
        </div>
    );
};
